import getSeason from '../components/Reports/util/getSeason';
import { all_percentiles } from '../dummy_data/all_percentiles';
import { all_percentiles_spanish } from '../dummy_data/all_percentiles_spanish';
import { getUserData } from './API';
import { FEATURE_FLAGS } from '../constants/featureFlags';

// TODO consider moving these constants into the constants directory
export const readingLevels = {
  beginner: "beginner",
  capable: "capable",
  proficient: "proficient",
};

const gradeToProficiencyMapping = [
  readingLevels.beginner,
  readingLevels.beginner,
  readingLevels.capable,
  readingLevels.proficient,
  readingLevels.proficient,
  readingLevels.proficient,
  readingLevels.proficient,
  readingLevels.proficient,
  readingLevels.proficient,
  readingLevels.beginner,
];

const proficientWPMCutoff = 75;
const capableWPMCutoff = 45;
const preWPMCutoff = 15;
const proficientErrorCutoff = 0.09;
const capableErrorCutoff = 0.20;
const preErrorCutoff = 0.50;

// TODO compare the child's speed to their own known speed,
// based on prior activities. For a child's first activity,
// use a norm for their specific age
// TODO double check Mark's accuracy values with Sharon or Billy
// (we should use a level that is about 15% below the typical accuracy rate for a student of this age)
const rushingThresholds = {
  preK: {
    wpm: 15,
    errorRate: .25,
  },
  kinder: {
    wpm: 15,
    errorRate: .25,
  },
  firstGrade: {
    wpm: 29.597,
    errorRate: .20,
  },
  secondGrade: {
    wpm: 66.128,
    errorRate: .15,
  },
  thirdGrade: {
    wpm: 84.853,
    errorRate: .1,
  },
  fourthGrade: {
    wpm: 105.659,
    errorRate: .1,
  },
  fifthGrade: {
    wpm: 115.833,
    errorRate: .1,
  },
  sixthGrade: {
    wpm: 116.833,
    errorRate: .1
  },
  seventhGrade: {
    wpm: 117.833,
    errorRate: .1
  },
  eighthGrade: {
    wpm: 118.833,
    errorRate: .1
  }
}

// Misspelling matches API
const grade_dict = {
  '-1': "Prekindergarten",
  0: "Kindergarden",
  1: "Firstgrade",
  2: "Secondgrade",
  3: "Thirdgrade",
  4: "Fourthgrade",
  5: "Fifthgrade",
  6: "Sixthgrade",
  7: "Seventhgrade",
  8: "Eighthgrade",
}
export function getDecodingPR(decoding, grade, locale = 'en-us') {
  // PreK percentiles are the same as Kindergarten, so override to grade 0
  if (grade === -1) {
    grade = 0;
  }

  const isSpanish = locale.toLowerCase() === 'es-mx';
  if (isSpanish && grade > 6) {
    // We don't have scores for Spanish 7th and 8th grade, so use 6th grade scores
    grade = 6;
  }

  const percentilesDict = isSpanish ? all_percentiles_spanish : all_percentiles;
  let prs = percentilesDict[getSeason()]['decodeScore'+grade_dict[grade]];
  let pr = 0;
  prs.some((percentileScore)=>{
    pr++;
    if(percentileScore > decoding) {
      return true;
    }
  });
  return pr;
}

export function getWCPMGradePR(wcpm, grade, locale = 'en-us') {
  // PreK percentiles are the same as Kindergarten, so override to grade 0
  if (grade === -1) {
    grade = 0;
  }

  const isSpanish = locale.toLowerCase() === 'es-mx';
  if (isSpanish && grade > 6) {
    // We don't have scores for Spanish 7th and 8th grade, so use 6th grade scores
    grade = 6;
  }
  
  const percentilesDict = isSpanish ? all_percentiles_spanish : all_percentiles;
  let prs = percentilesDict[getSeason()]['wcpmScore'+grade_dict[grade]];
  let pr = 0;
  prs.some((percentileScore)=>{
    pr++;
    if(percentileScore > wcpm) {
      return true;
    }
  });
  return pr;
}

let studentReadingLevel = readingLevels.beginner;
let studentGrade = null;
const GRADE_DEFAULT = 0;

export function setStudentReadingLevel(inLevel){
  //TODO add validation
  studentReadingLevel = inLevel;
}

export function getStudentReadingLevel(){
  return studentReadingLevel;
}

export function setStudentGradeLevel(grade) {
  // TODO add validation
  studentGrade = grade;
}

export function setStudentGradeLevelWithAREA(inArea){
  if(inArea < 6){
    studentGrade = 0;
  }else{
    if(inArea < 7){
      studentGrade = 1;
    }else{
      if(inArea < 8){
        studentGrade = 2;
      }else{
        if(inArea <9 )
          studentGrade = 4;
        else{
          studentGrade = 5;
        }
      }
    }
  }
  //###setStudentLevelByGrade(studentGrade);
  return studentGrade;
}

export function setStudentLevelByGrade(inGrade){
  const numericGrade = Number.parseInt(inGrade, 10);
  if(Number.isNaN(numericGrade)){
    studentReadingLevel = readingLevels.beginner;
    return;
  }
  let grade = (numericGrade > gradeToProficiencyMapping.length-2) ? (gradeToProficiencyMapping.length-2) : numericGrade; // Accounts for last index being for PREK
  studentReadingLevel = (grade === -1 ? gradeToProficiencyMapping[gradeToProficiencyMapping.length-1] : gradeToProficiencyMapping[grade]) || readingLevels.beginner;
}

export function getStudentGradeLevel(noDefault=false){
  return noDefault ? studentGrade : (studentGrade || GRADE_DEFAULT);
}

export function updateStudentReadingLevel(wpm,accuracy){
  let errorRate = 1-(accuracy/100);
  let newLevel = readingLevels.beginner;

  if((wpm > proficientWPMCutoff) && (errorRate < proficientErrorCutoff)){
    newLevel = readingLevels.proficient;
  }
  else if((wpm > capableWPMCutoff) && (errorRate < capableErrorCutoff)){
    newLevel = readingLevels.capable;
  }
  else if((wpm < preWPMCutoff) && (errorRate < preErrorCutoff)){
    //newLevel = readingLevels.pre; ###We don't support PRE anywhere. Keep here for when we do
  }
  setStudentReadingLevel(newLevel);
}

// This method attempts to discern whether the user is rushing.
// We're currently using the most recently calculated wpm and accuracy to make
// this determination.
// Note: current wpm calculation is based on *how far the student gets in the story*,
// NOT the length of their transcript
//
// Returns true if the reader is rushing
export function detectRushing(wpm, accuracy) {
  let errorRate = 1-(accuracy/100);
  // TODO: incorporate skips into this detection (potentially post-MVP)
  if (!wpm || !accuracy) {
    return false;
    console.log('error: invalid detectRushing params');
  }

  let gradeThresholds;
  switch(studentGrade) {
    case -1:
      gradeThresholds = rushingThresholds.preK;
      break;
    case 0:
      gradeThresholds = rushingThresholds.kinder;
      break;
    case 1:
      gradeThresholds = rushingThresholds.firstGrade;
      break;
    case 2:
      gradeThresholds = rushingThresholds.secondGrade;
      break;
    case 3:
      gradeThresholds = rushingThresholds.thirdGrade;
      break;
    case 4:
      gradeThresholds = rushingThresholds.fourthGrade;
      break;
    case 5:
      gradeThresholds = rushingThresholds.fifthGrade;
      break;
    case 6:
      gradeThresholds = rushingThresholds.sixthGrade;
      break;
    case 7:
      gradeThresholds = rushingThresholds.seventhGrade;
      break;
    case 8:
      gradeThresholds = rushingThresholds.eighthGrade;
      break;
    default:
      console.log('warning: grade out of range. Using highest available grade');
      gradeThresholds = rushingThresholds.eighthGrade;
  }
  let wpmThreshold = gradeThresholds.wpm;
  let errorThreshold = gradeThresholds.errorRate;

  if(wpm > wpmThreshold && errorRate > errorThreshold) {
    return true;
  }
  return false;
}

/**
 * Determines if a student is classified as a struggling reader.
 * 
 * The criteria used depends on the district's feature flag setting:
 * 
 * New criteria (when USE_NEW_STRUGGLING_READER_CRITERIA is enabled):
 * - WCPM (Words Correct Per Minute) is 30 or below AND
 * - ARM (Amira Reading Measure) score is 2 or below
 * 
 * Legacy criteria (when USE_NEW_STRUGGLING_READER_CRITERIA is disabled):
 * - WCPM (Words Correct Per Minute) is 50 or below AND
 * - AREA score is 7 or below
 * 
 * @returns {boolean} True if the student meets the criteria for a struggling reader
 */
export function isStrugglingReader(){
  const userData = getUserData();
  const districtId = userData.districtId;
  
  // Check if new criteria should be used for this district
  if (FEATURE_FLAGS.USE_NEW_STRUGGLING_READER_CRITERIA(districtId)) {
    // New logic: WCPM <= 30 AND ARM <= 2
    return userData.WCPM <= 30 && userData.ARM <= 2;
  }
  
  // Legacy logic: WCPM <= 50 AND AREA <= 7
  return userData.WCPM <= 50 && userData.AREA <= 7;
}
